export default "__VITE_ASSET__D7oJ1SQ4__"